import { t } from '@if/core/i18n';
import { formatCurrencyNoDecimals } from '@if/core/utils';
import { reportErrorToConsole } from '../services';
export const removePhoneFormat = (phoneFormated) => {
    let phone = phoneFormated.replace(' ', '');
    phone = phone.replace('(', '');
    phone = phone.replace(')', '');
    phone = phone.replace('-', '');
    return phone.substring(0, 10);
};
export const phoneFormat = (phone) => {
    if (!phone)
        return '';
    const formatedInputVal = phone.replace(/\D/g, '');
    const size = formatedInputVal.length;
    if (size > 6) {
        return `(${formatedInputVal.substring(0, 3)}) ${formatedInputVal.substring(3, 6)}-${formatedInputVal.substring(6, 10)}`;
    }
    else if (size > 3) {
        return `(${formatedInputVal.substring(0, 3)}) ${formatedInputVal.substring(3)}`;
    }
    else if (size > 0) {
        return `(${formatedInputVal}`;
    }
    return '';
};
export const extractMerchantNumber = (merchantId) => {
    const parts = merchantId.split('*');
    return parts[1] ?? '';
};
export const formatAddress = (address) => {
    if (!address)
        return 'N/A';
    let ret = '';
    if (address.civicNumber)
        ret = ret.concat(address.civicNumber);
    if (address.street)
        ret = ret.concat(` ${address.street}`);
    if (address.city)
        ret = ret.concat(`, ${address.city}`);
    if (address.stateIso)
        ret = ret.concat(`, ${address.stateIso}`);
    if (address.country)
        ret = ret.concat(`, ${address.country}`);
    if (address.postalCode)
        ret = ret.concat(`, ${address.postalCode?.toUpperCase()}`);
    return ret;
};
export const sinFormat = (sin) => {
    if (!sin)
        return sin;
    let formatedInputVal = sin.replace(/\D/g, '');
    const size = formatedInputVal.length;
    if (size > 3) {
        formatedInputVal = `${formatedInputVal.slice(0, 3)}-${formatedInputVal.slice(3)}`;
    }
    if (size > 6) {
        formatedInputVal = `${formatedInputVal.slice(0, 7)}-${formatedInputVal.slice(7)}`;
    }
    if (size > 9) {
        formatedInputVal = `${formatedInputVal.slice(0, 11)}`;
    }
    return formatedInputVal;
};
export const formatSIN = () => {
    const sin = document.querySelectorAll('.sin-input');
    function handleInput() {
        this.value = sinFormat(this.value);
    }
    sin.forEach((elem) => {
        elem.addEventListener('input', handleInput);
    });
};
export const removeSinFormat = (sinFormated) => {
    return sinFormated.replace(/-/g, '');
};
export function FormatCurrencyToNearestLowerMultipleToNoDecimals(data, roundDownTo) {
    let amount = 0;
    amount = parseFloat(data.toString());
    amount -= Math.round(amount) % roundDownTo;
    return formatCurrencyNoDecimals(amount);
}
export function FormatCurrencyToNearestUpperMultipleToNoDecimals(data, roundUpTo) {
    const amount = Math.ceil(data / roundUpTo) * roundUpTo;
    return formatCurrencyNoDecimals(amount);
}
export const formatDate = (date) => {
    if (!date) {
        return '';
    }
    if (typeof date === 'string') {
        const dateString = date.split('T')[0];
        if (/^\d{4}-\d{2}-\d{2}$/.exec(dateString)) {
            return dateString;
        }
        // eslint-disable-next-line no-param-reassign
        date = new Date(date);
    }
    if (date instanceof Date) {
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1;
        const day = date.getUTCDate();
        return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    }
    return '';
};
export const getValuesFromObject = (keys, values) => {
    const obj = {};
    keys.forEach((key) => {
        obj[key] = values[key];
    });
    return obj;
};
export function validateObjectValue(object, trigger) {
    const validate = (field) => trigger(field);
    const validateChildObject = (parentKey, value) => {
        Object.entries(value).forEach(([childKey, childValue]) => {
            if (childValue) {
                if (typeof childValue !== 'object')
                    validate(`${parentKey}.${childKey}`).catch(reportErrorToConsole);
                else if (typeof childValue === 'object')
                    setTimeout(() => validateChildObject(`${parentKey}.${childKey}`, childValue), 0);
            }
        });
    };
    Object.entries(object).forEach(([key, value]) => {
        if (value) {
            if (typeof value !== 'object')
                validate(key).catch(reportErrorToConsole);
            else if (typeof value === 'object')
                validateChildObject(key, value);
        }
    });
}
// Tooltip Adjustment
export const helpTip = () => {
    const helpTips = document.querySelectorAll('.help-tip');
    function handleMouseenter() {
        const tooltip = this.querySelector('p');
        if (tooltip) {
            const tooltipWidth = tooltip.offsetWidth;
            const tooltipOffset = this.getBoundingClientRect().left;
            const viewportWidth = window.innerWidth;
            if (tooltipOffset + tooltipWidth > viewportWidth) {
                tooltip.style.left = `${viewportWidth - tooltipOffset - tooltipWidth - 20}px`;
                tooltip.classList.add('no-arrow'); // Add a class to hide the arrow
            }
        }
    }
    function handleMouseleave() {
        const tooltip = this.querySelector('p');
        if (tooltip) {
            tooltip.style.left = '-0.4rem';
            tooltip.classList.remove('no-arrow');
        }
    }
    helpTips.forEach((element) => {
        element.addEventListener('mouseenter', handleMouseenter);
        element.addEventListener('mouseleave', handleMouseleave);
    });
};
export const scrollToTop = () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};
export const replaceWithNonBreakingHyphen = (hyphenatedString) => {
    return hyphenatedString.replaceAll('-', '\u2011');
};
export const replaceLastSpaceWithNbsp = (str) => {
    return str.replace(/\s(?=\S*$)/, '\u00A0');
};
export const calculateTotalMonths = (years, months = 0, useSelect = false) => {
    const MAX_MONTH_UNDER_ONE_YEAR = 11;
    if (useSelect) {
        return years === -1 ? MAX_MONTH_UNDER_ONE_YEAR : years * 12;
    }
    if (months === 0) {
        return years === -1 ? MAX_MONTH_UNDER_ONE_YEAR : years * 12;
    }
    return years * 12 + months;
};
export const setYearMonthValueFromMonths = (months, yearSelect, monthSelect, useSelectForYearsOfResidenceAndEmployment = true) => {
    const MAX_MONTH_UNDER_ONE_YEAR = 11;
    if (months) {
        yearSelect.value = '';
        const year = months === MAX_MONTH_UNDER_ONE_YEAR ? -1 : Math.trunc(months / 12);
        yearSelect.value = year.toString();
        if (monthSelect && !useSelectForYearsOfResidenceAndEmployment) {
            monthSelect.value = '';
            const month = months % 12;
            if (month > 0) {
                monthSelect.value = month.toString();
            }
            else {
                monthSelect.selectedIndex = 0;
            }
        }
        else if (monthSelect && useSelectForYearsOfResidenceAndEmployment === undefined) {
            const month = months % 12;
            const yearValue = Math.trunc(months / 12);
            if (yearValue > 0) {
                yearSelect.value = yearValue.toString();
            }
            else {
                yearSelect.selectedIndex = 0;
            }
            if (month > 0) {
                monthSelect.value = month.toString();
            }
            else {
                monthSelect.selectedIndex = 0;
            }
        }
    }
};
/**
 * @deprecated for comaptibility reason only. use hook or import "t" directly from i18n pour les messages éphémère (no refresh on lang change)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translate = (key, params) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return t(key, params);
};
export default translate;
/**
 * Gets the backend URL based on environment
 * In production, uses window.location.origin
 * In development, uses the provided local backend URL
 * @param isProd - Whether the app is running in production mode
 * @param localBackendUrl - The backend URL to use in development/local environment
 * @returns The appropriate backend URL with /api suffix
 */
export const getBackendUrl = (isProd, localBackendUrl) => {
    const baseUrl = isProd ? window.location.origin : localBackendUrl || '';
    return `${baseUrl}/api`;
};
export const getAddressApiBackendUrl = (isProd, localBackendUrl) => {
    const baseUrl = getBackendUrl(isProd, localBackendUrl);
    return `${baseUrl}`;
};
